export default "/_next/static/media/enjoei-reviews-attributes-1024x526.a9d99ece138f6580ea2f4a9cc5dd2a6b.png";